<template>
    <div class="lms__superadmin_workspaces_edit_apiintegration_table">
        <component-table
            :labels="[
                {
                    key: 'apiKey',
                    title: 'Key',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'issuedAt',
                    title: 'Date created',
                    type: 'date',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: 'string'
                }
            ]"
            :items="items"
            :component-table-item="LmsSuperadminWorkspaceEditApiIntegrationTableItem"
            :sort-queryable="sortQueryable"
            @emit-edit="handlePerformEmit({ message: 'emit-edit', value: arguments[0] })"
            @emit-empty-state-submit="handlePerformEmit({ message: 'emit-empty-state-submit' })"
            @emit-sort="handleSort"
        />
    </div>
</template>

<script>

import ComponentTable from '@/components/default/shared/ComponentTable'
import LmsSuperadminWorkspaceEditApiIntegrationTableItem from '@/components/lms/superadmin/workspace/edit/LmsSuperadminWorkspaceEditApiIntegrationTableItem'

export default {
  name: 'lms-superadmin-workspace-edit-self-registration-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminWorkspaceEditApiIntegrationTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    },
    componentTableAddActive: {
      type: Boolean
    }
  },
  methods: {
    handlePerformEmit (data) {
      const message = data.message
      const value = data.value
      this.$emit('emit', { message: message, value: value })
    },
    handleSort (data) {
      this.$emit('emit-sort', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/workspaces/_lmssuperadminworkspacesaddeditapiintegrationtable.scss";
</style>
